import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import'rxjs/add/operator/map';
import'rxjs/add/operator/filter';
import'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
import { LayoutService } from './layout.service';
export class MenuService {

      pageTitle = new BehaviorSubject<string>('');
      lazyLoad= true;
      sidenav = new BehaviorSubject([]);
      moduleIndex = new Subject<number>();
      startMenu = [];
      moduleActive = new Subject<string>();
/**
 * @param {?} router
 * @param {?} activeRoute
 * @param {?} loc
 * @param {?} _ls
 */
constructor(
private router: Router,
private activeRoute: ActivatedRoute,
private loc: Location,
private _ls: LayoutService
      ) {
            this.router.events
            .map(event => {
                  if (loc.path() !== '') {
                        const modulePath = loc.path().split('/')[1];
                        this.moduleActive.next(modulePath);
                        this.router.config.forEach((el, i) => {
                              if (el.path === modulePath) {
                                    this.moduleIndex.next(i);
                              }
                        });
                  }
                  return event;
            })
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.activeRoute)
            .map(route => {
                  while (route.firstChild) {route = route.firstChild; };
                  return route;
            })
            .filter(route => route.outlet === 'primary')
            .switchMap(route => route.data)
            .subscribe(res => {
                  this._ls.pageTitle.next(res.name);
                  this.pageTitle.next(res.name);
            });
            if (this.lazyLoad) {
                  this.moduleIndex.subscribe(res => {
                        if (this.router.config[res]['_loadedConfig']){
                              this.sidenav.next(this.router.config[res]['_loadedConfig'].routes[0].children)
                        }
                  });
            } else {
                  this.sidenav.next(this.router.config);
            }

            this.startMenu = this.router.config;
      }
/**
 * @param {?} url
 * @return {?}
 */
navigate(url: string){
            console.log(url);
            this.router.navigate(['/' + url]);
      }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: ActivatedRoute, },
{type: Location, },
{type: LayoutService, },
];
}

function MenuService_tsickle_Closure_declarations() {
/** @type {?} */
MenuService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MenuService.ctorParameters;
/** @type {?} */
MenuService.prototype.pageTitle;
/** @type {?} */
MenuService.prototype.lazyLoad;
/** @type {?} */
MenuService.prototype.sidenav;
/** @type {?} */
MenuService.prototype.moduleIndex;
/** @type {?} */
MenuService.prototype.startMenu;
/** @type {?} */
MenuService.prototype.moduleActive;
/** @type {?} */
MenuService.prototype.router;
/** @type {?} */
MenuService.prototype.activeRoute;
/** @type {?} */
MenuService.prototype.loc;
/** @type {?} */
MenuService.prototype._ls;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
